import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import IconAirportBlack from "../../assets/iconAirportBlack";
// Styles
import "../../assets/saas/molecules/_pickup-icon.scss";
import i18next from "i18next";
import { useModal } from "application/utils/useModal";
import { isTestMarketCountry } from "../../../utils/testMarket";
import { emitOpenMapModal } from "./mapModalLocations/useMapModal";
import MapModalLocationsLegacy from "./mapModalLocations/mapModalLocationsLegacy";
const PickupIcon = ({ text, locationType, pickupAddress, returnAddress, pickLatitude, pickLongitude, returnLatitude, returnLongitude, pickName, returnName, pickNameURL, returnNameURL, atAirportPickup, atAirportReturn, pickupLocationCode, returnLocationCode, }) => {
    const { isShown, toggle } = useModal();
    const [selectedLocation, setSelectedLocation] = useState(null);
    const resolveUserCountry = () => {
        var _a, _b;
        const countryFromSession = typeof window !== "undefined" ? sessionStorage.getItem("country") : null;
        const countryFromShopify = typeof window !== "undefined" ? (_a = window.Shopify) === null || _a === void 0 ? void 0 : _a.country : null;
        const normalized = ((_b = countryFromSession !== null && countryFromSession !== void 0 ? countryFromSession : countryFromShopify) !== null && _b !== void 0 ? _b : "US").toString().trim().toUpperCase();
        return normalized;
    };
    const shouldShowPickupNameURL = useMemo(() => {
        const normalizedCountry = resolveUserCountry();
        return !isTestMarketCountry(normalizedCountry);
    }, []);
    const translate = useMemo(() => {
        var _a;
        const translations = locationType === null || locationType === void 0 ? void 0 : locationType.translate;
        if (!(translations === null || translations === void 0 ? void 0 : translations.length)) {
            return locationType === null || locationType === void 0 ? void 0 : locationType.value;
        }
        const currentLanguage = (_a = i18next.language) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (!currentLanguage) {
            return locationType === null || locationType === void 0 ? void 0 : locationType.value;
        }
        const exactMatch = translations.find((translation) => { var _a; return ((_a = translation.language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === currentLanguage; });
        if (exactMatch) {
            return exactMatch.value;
        }
        const shortLang = currentLanguage.substring(0, 2);
        const shortMatch = translations.find((translation) => { var _a; return ((_a = translation.language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === shortLang; });
        return (shortMatch === null || shortMatch === void 0 ? void 0 : shortMatch.value) || (locationType === null || locationType === void 0 ? void 0 : locationType.value);
    }, [locationType]);
    const parseCoordinate = (value) => {
        if (value === undefined || value === null || value === "") {
            return undefined;
        }
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : undefined;
    };
    const handleHideModal = () => {
        setSelectedLocation(null);
        toggle();
    };
    const handleLocationClick = (type) => (e) => {
        e.stopPropagation();
        if (!shouldShowPickupNameURL) {
            openModalMap(e, type);
            return;
        }
        const isPickup = type === "pickup";
        const address = isPickup ? pickupAddress : returnAddress;
        if (!address) {
            return;
        }
        const latitude = isPickup ? pickLatitude : returnLatitude;
        const longitude = isPickup ? pickLongitude : returnLongitude;
        setSelectedLocation({
            title: `${translate || text || (isPickup ? "Pickup" : "Return")}`,
            address,
            lat: parseCoordinate(latitude),
            lng: parseCoordinate(longitude),
        });
        if (!isShown) {
            toggle();
        }
    };
    const openModalMap = (e, type) => {
        e.stopPropagation();
        let params = {
            locationsCodes: [pickupLocationCode, returnLocationCode],
        };
        if (atAirportPickup && pickupLocationCode === returnLocationCode) {
            params.locationsCodes = [params.locationsCodes[0].slice(0, -3), params.locationsCodes[1].slice(0, -3)]; // If both are the same and at airport, we only need to send one code
        }
        emitOpenMapModal(params);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "pickup-locations", children: [_jsxs("div", { className: "pickup-icon " + ((locationType === null || locationType === void 0 ? void 0 : locationType.cssclass) || ""), children: [atAirportPickup == false ? _jsx("img", { src: locationType.icon, alt: "icon" }) : _jsx(IconAirportBlack, {}), _jsx("span", { className: "airport_text", onClick: handleLocationClick("pickup"), children: atAirportPickup == true
                                    ? shouldShowPickupNameURL
                                        ? pickNameURL
                                        : pickName
                                    : shouldShowPickupNameURL
                                        ? pickupAddress
                                        : pickName })] }), pickupAddress != returnAddress && (_jsxs("div", { className: "pickup-icon " + ((locationType === null || locationType === void 0 ? void 0 : locationType.cssclass) || ""), children: [atAirportReturn == false ? _jsx("img", { src: locationType.icon, alt: "icon" }) : _jsx(IconAirportBlack, {}), _jsx("span", { className: "airport_text", onClick: handleLocationClick("return"), children: atAirportReturn == true
                                    ? shouldShowPickupNameURL
                                        ? returnNameURL
                                        : returnName
                                    : shouldShowPickupNameURL
                                        ? returnAddress
                                        : returnName })] }))] }), _jsx(MapModalLocationsLegacy, { isShown: isShown, hide: handleHideModal, defaultLocation: (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.address) || "South Beach, Miami Beach, FL", locations: selectedLocation ? [selectedLocation] : [], customClass: "map-locations-aviability" })] }));
};
export default PickupIcon;
